import React from 'react';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { WhyFailed } from './components/WhyFailed';
import { Mechanism } from './components/Mechanism';
import { Bundle } from './components/Bundle';
import { Audience } from './components/Audience';
import { HowItWorks } from './components/HowItWorks';
import { Proof } from './components/Proof';
import { Faq } from './components/Faq';
import { Offer } from './components/Offer';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
export function App() {
  return <div className="w-full min-h-full bg-cream font-sans text-ink" data-id="element-0" data-mp="31b8l22qjqjbb">
      <main data-id="element-1" data-mp="31cjog1g2xp1w">
        <Hero data-id="element-2" data-mp="2wk06yte9u9rt" />
        <Problem data-id="element-3" data-mp="2wjgptewg3peu" />
        <WhyFailed data-id="element-4" data-mp="2wiyvintcfl9k" />
        <Mechanism data-id="element-5" data-mp="2wifbn1k4umsw" />
        <Bundle data-id="element-6" data-mp="2wi5n7ieqknpb" />
        <Audience data-id="element-7" data-mp="28ufm24yk52fw" />
        <HowItWorks data-id="element-8" data-mp="28tmex2vosax8" />
        <Proof data-id="element-9" data-mp="28t4lsf4bmctj" />
        <Faq data-id="element-10" data-mp="28sl3gxardmez" />
        <Offer data-id="element-11" data-mp="28sbad0uf2z52" />
      </main>
      <Footer data-id="element-12" data-mp="23vktwcepa1j4" />
      <StickyCta data-id="element-13" data-mp="23w4e5zrtp20b" />
    </div>;
}